import React, {useCallback, useMemo} from 'react';
import {connect} from "react-redux";
import {THUMBNAIL_SIZES} from "../../../../../../../misc/utils";
import LookFeaturePrice from "../../../../../../look/lookNavigation/lookMain/lookListFeature/lookFeaturePrice";
import FeatureName from "../../../../../../visComponents/featureName";
import FeatureDescription from "../../../../../../visComponents/featureDescription";
import {featureThumbnailUrl} from "../../../../../../../misc/helpers";
import CheckIcon from "@mui/icons-material/Check";

const FeaturesRow = (props) => {
  const { feature, index, style, parentFeature, activeItemIndex, setActiveItemIndex, itemClickCallback } = props;
  const { lookViewType } = props;
  const isActive = activeItemIndex === index;

  const className = useMemo(() => {
    return "lm-feature lm-feature--type-" + lookViewType + (isActive ? " lm-feature--active" : "");
  }, [isActive, lookViewType]);

  const imageUrl = useMemo(() => featureThumbnailUrl(feature, THUMBNAIL_SIZES.medium), [feature]);

  const handleButtonClick = useCallback((e) => {
    e.preventDefault();
    setActiveItemIndex(index);
    itemClickCallback(e, feature, parentFeature);
  }, [index, feature, parentFeature, setActiveItemIndex, itemClickCallback]);

  return (
    <div
      className={className}
      style={style}
      key={index}
      draggable
      onClick={handleButtonClick}
    >
      <div className={"lm-feature__thumbnail lm-feature__thumbnail--full "}>
        {isActive ? (
          <div className="lm-feature__checkmark">
            <CheckIcon fontSize="small"/>
          </div>
        ) : null}
        {imageUrl ? <img src={imageUrl} className="feature-thumbnail__image" alt="" /> : null}
      </div>
      <div className={"lm-feature__content"}>
        <div className="lm-feature__content-name">
          {feature.getFeatureName()}
        </div>
        <div className="lm-feature__content-description">
          <FeatureDescription feature={feature} textLength={80}/>
        </div>
        <div className="lm-feature__content-price">
          <LookFeaturePrice showPriceAlways={true} lookFeature={feature} listPage={true} className="lm-feature__content-price-text"/>
          {lookViewType === 4 ? <FeatureName feature={feature} useCollectionName={true}/> : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const { menuOpened } = store.sqftMenuState;
  const { visualizersLoaded, windowHeight, isMobile } = store.serverState;
  const { lookViewType } = store.lookState;

  return {
    menuOpened,
    windowHeight,
    isMobile,
    lookViewType,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(FeaturesRow);
